<template>
    <div class="GuestsArrival">

        <div id="printView" v-if="!$store.state.isTablet">
            <div v-bind:style="event.isConference ? 'width: 264px;margin:0px;text-align:center;font-size:32px;font-weight:bold' : 'width: 302px;margin:0px'">
                <img v-if="!event.isConference" v-bind:src="$store.state.printAssets.logo" width="300" height="77"/>
                <br v-if="!event.isConference"/>

                <span v-if="!event.isConference" class="title">{{ event.name }}</span>
                <br v-if="!event.isConference"/>

                <img v-bind:src="$store.state.printAssets.divider" v-if="!event.isConference"/>
                <div v-if="!event.isConference" style="width:100%;height:3px;background-color: #ccc;margin:10px 10px 10px 10px"></div>
                <br v-if="!event.isConference"/>
                {{ guestObj.fullName + (guestObj.status.coming > 1 ? ` ${guestObj.status.coming}` : '') }}

                <br v-if="event.isConference && guestObj.company && guestObj.company !== ''"/>
                <span v-if="event.isConference && guestObj.company && guestObj.company !== ''">{{ guestObj.company }}</span>

                <br v-if="event.isConference && guestObj.role && guestObj.role !== ''"/>
                <span v-if="event.isConference && guestObj.role && guestObj.role !== ''">{{ guestObj.role }}</span>

                <br v-if="!event.isConference"/>
                {{(getTables().length > 0  ? $t('table') + ' ' + getTables().join(',') : (event.isConference ? '' : $t('notSeatedGuest_2'))) }}
                <br v-if="!event.isConference"/>

                <img v-if="guestObj.hasOwnProperty('printNote') && guestObj.printNote !== '' && guestObj.printNote && !event.isConference" v-bind:src="$store.state.printAssets.divider"/>
                <div v-if="guestObj.hasOwnProperty('printNote') && guestObj.printNote !== '' && guestObj.printNote && event.isConference" style="width:100%;height:3px;background-color: #ccc;margin:10px 10px 10px 10px"></div>

                <br v-if="!event.isConference && guestObj.hasOwnProperty('printNote') && guestObj.printNote !== '' && guestObj.printNote"/>
                {{ guestObj.printNote ? guestObj.printNote : '' }}
                <br v-if="!event.isConference && guestObj.hasOwnProperty('printNote') && guestObj.printNote !== '' && guestObj.printNote"/>

                <div class="footer" v-if="!event.isConference">
                    {{ $store.state.app.domain === 'app.seatup.co.il' || $store.state.app.domain === 'dev' ? '052-644-3837' : contactPhone }}<br/>
                    {{ $store.state.app.domain === 'app.seatup.co.il' || $store.state.app.domain === 'dev' ? "www.seatup.co.il" : $store.state.app.domain }}
                </div>
            </div>
        </div>

        <div class="innerMainContent">
            <div class="innerHeader">
                <div class="h1Wrap" style="width: 50%;">
                    <svg class="i_calender"><use xlink:href="#i_calender"></use></svg>
                    <div class="innerH1Wrap">
                        <h1>{{ `${$t('page_title_arrival')} - ${event.name}` }}</h1>
                        <ul class="breadcrumb">
                            <li><router-link to="/">{{ $t('page_title_dashboard') }}</router-link></li>
                            <li><router-link v-bind:to="'/event/wedding/'+event.id">{{ $t('event') }}</router-link></li>
                            <li class="active">{{ $t('page_title_arrival') }}</li>
                        </ul>
                    </div>
                </div>
                <div class="editEventActions">
                    <button class="addEvent" @click="showAddGuest()">
                        <svg><use xlink:href="#i_add_user"></use></svg>
                        <span>{{ $t('addGuest') }}</span>
                    </button>
                    <button class="addEvent" @click="getEventData()">
                        <svg><use xlink:href="#i_download"></use></svg>
                        <span>{{ $t('refreshData') }}</span>
                    </button>
                </div>
            </div>
            <div class="innerBox filterBox">
                <form @submit.prevent="">
                    <h3>
                        <svg><use xlink:href="#i_filter"></use></svg>
                        <span>{{ $t('filterGuests') }}</span>
                    </h3>
                    <div class="inputWrap">
                        <label for="tableNum">{{ $t('tableNum') }}</label>
                        <div class="selectWrap">
                            <select name="tableNum" id="tableNum" v-model="tableNum">
                                <option value="" selected="selected">{{ $t('select') }}</option>
                                <option v-for="table of tables()" v-bind:value="table.dbID">{{ table.tableNum }}</option>
                            </select>
                            <svg class="i_select"><use xlink:href="#i_select"></use></svg>
                        </div>
                    </div>
                    <div class="inputWrap">
                        <label for="group">{{ $t('group') }}</label>
                        <div class="selectWrap">
                            <select name="group" id="group" v-model="group">
                                <option value="" selected="selected">{{ $t('select') }}</option>
                                <option v-for="group of groups()">{{ group }}</option>
                            </select>
                            <svg class="i_select"><use xlink:href="#i_select"></use></svg>
                        </div>
                    </div>
                    <div class="orDivider">{{ $t('or') }}</div>
                    <div class="inputWrap searchWrapper">
                        <input type="search" v-bind:placeholder="$t('guestName') + '...'" v-model="guest">
                        <button class="searchEvent">
                            <svg><use xlink:href="#i_search"></use></svg>
                            <span class="sr-only">{{ $t('searchEvent') }}</span>
                        </button>
                    </div>
                    <div class="clearfix">
                        <h3>
                            <span>{{ $t('currentArrivalStatus') }}</span>
                        </h3>
                        <div>
                            <ul>
                                <li><strong>{{ arrived }}</strong> {{ $t('arrived') }}</li>
                                <li><strong>{{ seated }}</strong> {{ $t('seated') }}</li>
                                <li><strong>{{ percentage }}%</strong> {{ $t('attendance') }}</li>
                            </ul>
                        </div>
                    </div>
                </form>

            </div>
            <div class="col-xs-12 tables">
                <div class="eventTable">
                    <table>
                        <tr>
                            <th></th>
                            <th>{{ $t('guestName') }}</th>
                            <th>{{ $t('group') }}</th>
                            <th>{{ $t('tableNum') }}</th>
                            <th>{{ $t('quantity') }}</th>
                            <th v-if="!$store.state.isTablet">{{ $t('print') }}</th>
                        </tr>
                        <GuestArrivalRow class="guestArrivalRow" v-for="guest of getGuests()" :key="guest.id" :guest="guest" v-on:print="printGuest(guest)" v-on:updateGuest="updateGuest" :tables="tables()"></GuestArrivalRow>

                        <tr v-if="getGuests().length === 0">
                            <td colspan="4" style="text-align: center">{{ $t('makeSearch') }}</td>
                        </tr>

                    </table>
                </div>
            </div>
        </div>
        <AddGuestModal :event="this.event.id" v-on:addGuest="addGuest" :short="true"></AddGuestModal>
    </div>
</template>

<script>
    import GuestArrivalRow from './GuestArrivalRow'
    import AddGuestModal from './AddGuestModal'

    export default {
        name: "GuestsArrival",
        data(){
            return{
                guest:'',
                tableNum:'',
                group:'',
                event:{presetData:[]},
                guests:[],
                guestObj:{status:{}},
                backgroundDataRefresh:null,
                intervalTiming:5000
            }
        },
        computed:{
            contactPhone:function(){
                return (this.$store.state.hasOwnProperty("app") && this.$store.state.app.hasOwnProperty("admin") && this.$store.state.app.admin.hasOwnProperty("phone") && this.$store.state.app.admin.phone !== "" ? this.$store.state.app.admin.phone : this.$t('defaultPhone'))
            },
            arrived(){

                let arrived = 0;
                if(this.event.hasOwnProperty('id') && this.event.hasOwnProperty('guests')){
                    this.guests.forEach(guest => {
                        if(guest.arrived) arrived += parseInt(guest.quantity) > 0 ? parseInt(guest.quantity) : 1;
                    });
                }

                return arrived;
            },

            seated(){

                let seated = 0;
                if(this.event.hasOwnProperty('id') && this.event.hasOwnProperty('guests')){
                    this.guests.forEach(guest => {
                        if(guest.tableID !== "" && guest.tableID) seated += guest.quantity;
                    });
                }

                return seated;
            },

            percentage(){
                let percentage = parseInt((this.arrived/this.seated)*100);
                return isNaN(percentage) ? 0 : percentage;
            }
        },
        components:{
            GuestArrivalRow,
            AddGuestModal
        },
        beforeDestroy(){
            clearInterval(this.backgroundDataRefresh);
        },
        destroyed(){
            $("#modal-addGuest").remove();
            clearInterval(this.backgroundDataRefresh);
        },
        beforeMount(){
            const eventID = this.$router.currentRoute.params.eventID;
            if(typeof eventID !== 'undefined' && eventID !== ''){
                this.event.id = eventID;
                this.getEventData();
                this.backgroundDataRefresh = setInterval(this.getEventData,this.intervalTiming)
            } else {
                this.$router.push('/');
            }

            try{
                window.seatupApp.loadPrintAssets();
            } catch(e){
                console.log(`failed to fetch print logo - ${e.message}`)
            }

        },
        methods:{
            tables(){
                return this.event.presetData.filter(_item=>_item.type === 'table').map(table=>Object.assign(table,{show:table.hasOwnProperty('show') ? table.show : false}));
            },
            getGuests(){
                return this.guests.filter(guest => {
                    if(this.guest === '' && this.group === '' && this.tableNum === '') return true;

                    if(this.guest !== null && this.guest !== '' && guest.fullName.toString().toLowerCase().includes(this.guest.toString().toLowerCase())) return true;
                    if(this.group !== null && guest._group !== null && this.group !== '' && guest._group.toString().toLowerCase().includes(this.group)) return true;
                    if(this.tableNum !== null && this.tableNum !== '' && guest.tableID !== null && guest.tableID !=='' && guest.tableID.toString() == this.tableNum.toString()) return true;
                    return false;
                });
            },
            getEventData(){
                this.$store.dispatch('getEvent',this.event.id)
                    .then(response =>{
                        //success
                        this.event = response.data;
                        this.$store.dispatch('getGuests',this.event.id)
                                                .then(response =>{
                                                    //success
                                                    this.guests = response.data.sort((a, b) => a.fullName.toString().localeCompare(b.fullName.toString()));
                                                })
                                                .catch(err => {
                                                    //err
                                                    //err
                                                    this.$swal({
                                                        confirmButtonText:this.$t('okButton'),
                                                        type:'error',
                                                        title:this.$t('fatalError'),
                                                        timer:3000
                                                    }).catch(this.$swal.noop);
                                                    this.$router.push('/');
                                                })
                    })
                    .catch(err => {
                        //err
                        this.$swal({
                            confirmButtonText:this.$t('okButton'),
                            type:'error',
                            title:this.$t('fatalError'),
                            timer:3000
                        }).catch(this.$swal.noop);
                        this.$router.push('/');
                    })
            },

            groups(){
                if(!this.guests) return [];
                return this.guests.filter(guest=>guest._group && guest._group !== "").map(_guest=>_guest._group).filter((elem, pos, arr)=>arr.indexOf(elem) === pos).filter(_group=>_group !== '').sort((a,b)=>b.toString().localeCompare(a.toString()));
            },

            updateGuest(guest){
                this.$store.dispatch('updateGuest',guest);
            },

            showAddGuest(){
                let _this = this;
                $('[data-id="eventID"]').val(this.event.id);
                setTimeout(function(){
                    $('[data-id="eventID"]').val(_this.event.id);
                },1000);
                $('.addGuestForm input').val('');
                $('.addGuestForm #gQuantity').val('1');
                $('.addGuestForm .value.vQyt').text("1");
                $("#modal-addGuest").iziModal({
                    autoOpen: 1
                });
            },

            addGuest(_){
                this.guests.push(_);
                this.getEventData();
            },

            printGuest(guest){
                this.guestObj = guest;
                setTimeout(()=>{
                    $('#printView').show().css({display:'inline'});
                    printJS({honorMarginPadding :false,printable: 'printView',type:'html',header:null,targetStyles:['*']})
                    $('#printView').hide();
                },500);
            },

            getTables(){
                if(!this.guestObj.tableNumber) return [];
                let tables = [this.guestObj.tableNumber];
                let table = {};

                this.event.presetData.some(tbl=>{
                    if(tbl.dbID === this.guestObj.tableID){
                        table = tbl;
                        return true;
                    }
                });

                if(this.event.groupSeating && table.hasOwnProperty('name') && table.name && table.name !== ''){
                    tables = this.event.presetData.filter(tbl=>tbl.hasOwnProperty('name') && tbl.name === table.name).map(tbl=>tbl.tableNum)
                }

                if(tables.length){
                    const _tables = Object.assign([],tables);

                    try {
                        tables.sort((a,b)=>a-b)

                        //check if table numbers
                        tables = this.groupArray(tables.map(table => parseInt(table)));
                        for(const i in tables){
                            if(tables.hasOwnProperty(i) && tables[i].length > 1){
                                tables[i] = `${Math.min(...tables[i])}-${Math.max(...tables[i])}`;
                            }
                        }
                    } catch (e){
                        // i dont care
                        tables = _tables;
                    }

                }
                return tables;
            },
        }
    }
</script>

<style>
    @media print {
        body{
            color:black
        }
    }
    .GuestsArrival .tables .tableItem{
        padding-right:0px;
        padding-left:0px;
        padding-top:10px;
        cursor: pointer;
    }
    .GuestsArrival .tables .tableFooter svg.i_longArr{
        fill:#2A3A5B;
    }
    .GuestsArrival .tables .tableFooter svg.i_longArr{
        height:10px;
        width:20px
    }
    .GuestsArrival .tables .tableFooter{
        background-color: #ECECEC;
        font-size:13px
    }
    .GuestsArrival .tables .tableData{
        font-size: 15px;
        padding-bottom: 5px;
    }
    .GuestsArrival .tables .tableData ul li span{
        font-weight: bold;
        color: #8FA7CB;
    }
    .GuestsArrival .tables .tableHeader .border{
        border-top: #8FA7CB 2px solid;
        line-height: 5px;
    }
    .GuestsArrival .tables .tableHeader{
        padding-left: 0px;
        padding-right: 0px;
    }
    .GuestsArrival .tables .tableHeader .arrivalStatus{
        font-size: 15px;
        vertical-align: 3px;
    }
    .GuestsArrival .tables .tableHeader .arrivalStatus span:nth-child(1){
        opacity: .7;
    }
    .GuestsArrival .tables .tableHeader .arrivalStatus span+span{
        font-weight: bold;
        font-style: italic;
    }
    .GuestsArrival .tables .tableHeader svg{
        width:17px;
        height:17px;
    }
    .GuestsArrival .tables .tableHeader .i_table{
        stroke:black;
        width:20px;
        height:20px;
    }
    .GuestsArrival .tables .tableHeader span.tableNum{
        vertical-align: 4px;
        font-weight: bold;
    }

    .GuestsArrival .tables .tableItem{
        -webkit-box-shadow: 0px 0px 27px 0px rgba(0, 0, 0, 0.13);
        box-shadow: 0px 0px 27px 0px rgba(0, 0, 0, 0.13);
        background: #fff;
        border: 2px solid #f3f3f3;
        float: right;
    }
    .GuestsArrival .innerMainContent{
        padding:55px 45px;
        float: right;
        width:100%;
    }

    .GuestsArrival .editEventActions{
        float:left;
        margin-top: 6px;
    }
    .GuestsArrival .editEventActions .backBtn span{
        color:#7c97c5;
        font-weight:700;
        font-size:1.235rem;
        display:inline-block;
        vertical-align:middle;
    }
    .GuestsArrival .editEventActions .backBtn svg{
        display:inline-block;
        vertical-align:middle;
        width:26px;
        height:18px;
        fill:#293b5a;
        margin-right:5px;
    }

    .GuestsArrival .tooltiptopicevent{

        width: 260px;
        position: absolute;
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.09);
        background: #fff;
        transform: translate(-58%,26px);
    }
    .GuestsArrival .tooltipHeader{
        background: #f2f2f2;
        border-bottom:1px solid #b1e2f9;
        text-align: left;
        padding: 10px;
    }
    .GuestsArrival .tooltipHeader:before{
        content: "";
        width: 0;
        height: 0;
        border-left: 12px solid transparent;
        border-right: 12px solid transparent;
        border-bottom: 12px solid #f2f2f2;
        position: absolute;
        bottom: 100%;
        right: calc(50% - 6px);
    }
    .GuestsArrival .tooltipHeader .closeBtn button{
        display:inline-block;
        vertical-align: middle;
    }
    .GuestsArrival .tooltipHeader .closeBtn svg{
        width:15px;
        height:15px;
        fill:#969696;
    }
    .GuestsArrival .tooltipHeader .editEventBtn svg{
        width:14px;
        height:15px;
        fill:#293b5a;
    }
    .GuestsArrival .tooltipHeader .deleteEventBtn svg{
        width:13px;
        height:17px;
        fill:#969696;
    }
    .GuestsArrival .tooltipTitle{
        text-align: right;
    }
    .GuestsArrival .tooltipTitle span{
        color:#7994c2;
        font-weight: bold;
        font-size:0.8824rem;
    }
    .GuestsArrival .tooltipTitle span + span{
        color:#293b5a;
        font-weight: bold;
        font-size:0.8824rem;
        font-style: italic;
    }
    .GuestsArrival .tooltipContent ul{
        padding: 7px 0;
    }
    .GuestsArrival .tooltipContent ul li {
        padding: 2px 15px;
    }
    .GuestsArrival .tooltipContent ul li svg{
        display: inline-block;
        vertical-align: middle;
        margin-left: 10px;
        width:16px;
        height:16px;
        fill:#848484;
    }

    .GuestsArrival .tooltipContent ul li span{
        display: inline-block;
        vertical-align: middle;
        color:#848484;
        font-size: 0.7647rem;
    }
    .GuestsArrival .addEvent{
        width: 181px;
        height: 42px;
        border: 1px solid #52dbcd;
        border-radius: 21px;
        background: -moz-linear-gradient(0deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        /* ff3.6+ */
        background: -webkit-gradient(linear, left top, right top, color-stop(0%, rgba(41, 59, 90, 1)), color-stop(100%, rgba(123, 150, 196, 1)));
        /* safari4+,chrome */
        background: -webkit-linear-gradient(0deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        /* safari5.1+,chrome10+ */
        background: -o-linear-gradient(0deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        /* opera 11.10+ */
        background: -ms-linear-gradient(0deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        /* ie10+ */
        background: linear-gradient(90deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        /* w3c */
        filter: progid: DXImageTransform.Microsoft.gradient( startColorstr='#293b5a', endColorstr='#7b96c4', GradientType=1 );
        /* ie6-9 */
    }
    .GuestsArrival .addEvent svg{
        display: inline-block;
        vertical-align: middle;
        width: 15px;
        height: 15px;
        fill: #fff;
        margin-left: 10px;
    }
    .GuestsArrival .addEvent span{
        display: inline-block;
        vertical-align: middle;
        margin-top: -2px;
        font-size: 0.8235rem;
        font-weight: 700;
        color:#fff;
    }
    .GuestsArrival .innerBox.filterBox{
        margin-bottom:20px;
        padding:23px;
    }

    .GuestsArrival .innerBox.filterBox h3{
        display: inline-block;
        vertical-align: middle;
    }
    .GuestsArrival .innerBox.filterBox h3 span{
        color:#293b5a;
        font-size: 1rem;
        display: block;
        font-weight: 700;
        margin-top:10px;
    }
    .GuestsArrival .innerBox.filterBox h3 svg{
        width:24px;
        height:24px;
        display: block;
        margin:0 auto;
        fill:#293b5a;
    }
    .GuestsArrival .innerBox.filterBox .inputWrap{
        display: inline-block;
        vertical-align: middle;
        margin-right:15px;
        width:250px;
    }
    .GuestsArrival .innerBox.filterBox  .inputWrap + .inputWrap{
        margin-top:0;

    }
    .GuestsArrival .innerBox.filterBox .inputWrap label{
        color:#293b5a;
        font-size: 0.8824rem;
        font-weight: bold;
    }
    .GuestsArrival .innerBox.filterBox .inputWrap input,
    .GuestsArrival .innerBox.filterBox .inputWrap select{
        background:#fff;
        color:#434343;
    }
    .GuestsArrival .innerBox.filterBox .inputWrap select#eventStatus{
        background: #f6f6f6
    }
    .GuestsArrival .innerBox.filterBox .inputWrap.searchWrapper{
        width:335px;
    }
    .GuestsArrival .innerBox.filterBox .inputWrap.searchWrapper input{
        padding-left: 40px;
    }
    .GuestsArrival .innerBox.filterBox .inputWrap.searchWrapper .searchEvent{
        position: absolute;
        top: calc(50% - 10px);
        left: 20px;
    }
    .GuestsArrival .innerBox.filterBox .inputWrap.searchWrapper .searchEvent svg{
        fill: #293b5a;
        width: 18px;
        height: 20px;
        display: block;
    }
    .GuestsArrival .orDivider{
        display: inline-block;
        height: 54px;
        width: 54px;
        line-height: 54px;
        text-align: center;
        border-radius: 50%;
        background: #e0e0e0;
        color: #414141;
        font-size: 1rem;
        font-style: italic;
        margin: 0px 15px;
        vertical-align: bottom;
    }
    .GuestsArrival .searchWrapper input[type="search"]{
        width:100%;
        height:unset;
        padding-bottom:unset;
    }
    .GuestsArrival .searchWrapper{
        margin-top: 25px;
    }
    .GuestsArrival .eventTable{
        width:100%;
        float: right;
        margin-top:25px;
        position:relative;
    }
    .GuestsArrival .eventTable table{
        width:100%;
        border-spacing: 1px;
    }
    .GuestsArrival .eventTable table tr:first-child{
        border-bottom:1px solid #293b5a;

    }
    .GuestsArrival .eventTable table tr th{
        padding:15px;
        color:#7b96c4;
        font-weight:700;
        font-size:1.176rem;
    }
    .GuestsArrival .eventTable table tr td{
        padding:13px;
        color:#5a5a5a;
        font-size:1rem;
    }
    .GuestsArrival .eventTable table tr{
        background: #fff;
        /*border:1px solid transparent;*/

    }
    /*.GuestsArrival .eventTable table tr:hover,
    .GuestsArrival .eventTable table tr.focusInClass{
        border-color:#56e2d4;
    }*/
    .GuestsArrival .eventTable table tr:nth-child(2n+2){
        background: #f0f0f0;
    }
    .guestArrivalRow svg{
        height:15px;
        width:15px;
    }
    .GuestsArrival .addGuest{
        border: 1px solid #52dbcd;
        background: -moz-linear-gradient(0deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        /* ff3.6+ */
        background: -webkit-gradient(linear, left top, right top, color-stop(0%, rgba(41, 59, 90, 1)), color-stop(100%, rgba(123, 150, 196, 1)));
        /* safari4+,chrome */
        background: -webkit-linear-gradient(0deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        /* safari5.1+,chrome10+ */
        background: -o-linear-gradient(0deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        /* opera 11.10+ */
        background: -ms-linear-gradient(0deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        /* ie10+ */
        background: linear-gradient(90deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        /* w3c */
        filter: progid: DXImageTransform.Microsoft.gradient( startColorstr='#293b5a', endColorstr='#7b96c4', GradientType=1 );
        /* ie6-9 */
    }
    .GuestsArrival .addGuest svg{
        display: inline-block;
        vertical-align: middle;
        width: 24px;
        height: 24px;
        fill: #fff;
        margin-left: 5px;
    }
    .GuestsArrival .addGuest span{
        display: inline-block;
        vertical-align: middle;
        margin-top: -2px;
        font-size: 0.8235rem;
        font-weight: 700;
        color:#fff;
    }


    .GuestsArrival @page {
        margin: 0;
    }
    .GuestsArrival #printView{
        font-family: Arial;
        font-size:25px;
        width:100%;
        text-align: center;
        display: none;
        color:black !important;
    }
    .GuestsArrival #printView .title{
        font-weight: bold;
    }
    .GuestsArrival #printView .footer{
        font-size: 17px;
        margin-top: 10px;
        border-top: 1px solid #a8a8a8;
    }
</style>
